import RightDocSidebar from "../../components/RightSidebar";
import { Link } from "react-router-dom";

import OpeningBalances from "../../components/Accounting Module/OpeningBalances";
import ChartOfAccounts from "../../components/Accounting Module/ChartofAccounts";
import JournalEntries from "../../components/Accounting Module/JournalEntries";
import AccountLedger from "../../components/Accounting Module/LedgerbyAccount";
import TrialBalance from "../../components/Accounting Module/TrialBalance";
import ProfitLoss from "../../components/Accounting Module/Profit-loss";
import BalanceSheet from "../../components/Accounting Module/BalanceSheet";
import DocNavigation from "../../components/DocNavigation";

export default function Accounting() {
    const groups = [
        { title: "1. Opening Balances", expandable: false, items: [{ id: "opening-balances" }] },
        { title: "2. Chart of Accounts", expandable: false, items: [{ id: "chart-of-accounts" }] },
        { title: "3. Journal Entries", expandable: false, items: [{ id: "journal-entries" }] },
        { title: "4. Ledger By Account", expandable: false, items: [{ id: "ledger-by-account" }] },
        { title: "5. Trial Balance", expandable: false, items: [{ id: "trial-balance" }] },
        { title: "6. Profit & Loss", expandable: false, items: [{ id: "profit-loss" }] },
        { title: "7. Balance Sheet", expandable: false, items: [{ id: "balance-sheet" }] },
    ];

    return (
        <div className="flex gap-12">

            {/* MAIN CONTENT */}
            <div className="flex-1 space-y-16">

                {/* STANDARD TITLE SECTION (SAME EVERYWHERE) */}
                <section className="bg-white rounded-xl border border-slate-200 p-10">
                    <h1 className="text-2xl font-bold text-slate-900 mb-4">
                        Accounting Module
                    </h1>

                    <p className="text-md text-slate-600 max-w-3xl">
                        The Accounting module provides complete financial control by managing
                        balances, transactions, ledgers, and financial statements across
                        EventFlow.
                    </p><br />
                    <p className="text-slate-600">
                        This module automatically consolidates financial data from bookings,
                        receipts, expenses, purchases, and payments — ensuring accuracy,
                        compliance, and audit-ready records.
                    </p>
                </section>

                {/* INTRO */}
                {/* <section className="bg-slate-100 rounded-xl p-8">
                    <h2 className="font-semibold mb-2">Overview</h2>
                    
                </section> */}

                {/* SUB COMPONENTS */}
                <OpeningBalances />
                <ChartOfAccounts />
                <JournalEntries />
                <AccountLedger />
                <TrialBalance />
                <ProfitLoss />
                <BalanceSheet />

                {/* <section className="border-t pt-8 mt-12">
                    <p className="text-slate-600">
                        Next, continue to the{" "}
                        <Link
                            to="/docs/access-control"
                            className="font-medium text-[#C9A24E]"
                        >
                            Access Control Module.
                        </Link>{" "}
                    </p>
                </section> */}

                <DocNavigation
                    previous={{
                        title: "Procurement Module",
                        link: "/docs/procurement"
                    }}
                    next={{
                        title: "Access Control Module",
                        link: "/docs/access-control"
                    }}
                />
            </div>

            {/* RIGHT SIDEBAR */}
            <RightDocSidebar groups={groups} />

        </div>
    );
}
